<template>
  <div>
    <exo-table overviewAction :root="_self">
      <exo-form :root="_self">
        <template v-slot:titleTooltip>
          <exo-help-dialog
            :color="'black--text'"
            :margin="'m-0'"
            title="InspectionMission"
          >
            <tooltipInspectionMission />
          </exo-help-dialog>
        </template>
        <exo-input-name :root="_self" />
        <exo-card-form label="Leader">
          <v-row no-gutters justify="start">
            <exo-input-ref-notparametric
              :root="_self"
              name="spacecraft"
              type="spacecraft"
              componentRoute="/numericalspacecraft"
            />
            <exo-input-ref-notparametric
              :root="_self"
              name="initialOrbit"
              type="orbit"
              componentRoute="/numericalorbit"
            />
          </v-row>
          <exo-form-alert
            type="error"
            v-if="
              this.inputs.initialOrbit != null &&
              (this.inputs.initialOrbit.perigeeAltitude > 2000000 ||
                this.inputs.initialOrbit.eccentricity > 2e-3)
            "
          >
            Inspection only works on LEO near circular orbit (altitude &lt
            2000km and eccentricity &lt 2e-3).
          </exo-form-alert>
          <exo-form-alert
            type="error"
            v-if="
              this.inputs.spacecraft != null &&
              this.inputs.spacecraft.thruster.thrust /
                this.inputs.spacecraft.platformMass <
                1.4e-4
            "
          >
            Spacecraft need a propulsion system with thrust acceleration higher
            than 1.4e-4 to do inspection mission. Please increase the propulsion
            thrust or decrease the spacecraft mass.
          </exo-form-alert>
        </exo-card-form>
        <exo-card-form
          label="Follower initial conditions relative to target, TNW frame"
        >
          <v-row no-gutters>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceX"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceY"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceZ"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVX"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVY"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVZ"
              />
            </v-col>
          </v-row>
        </exo-card-form>
        <exo-card-form label="Inspection parameters">
          <v-row no-gutters>
            <exo-input-double :root="_self" name="distanceFromChief" />
            <exo-input-double :root="_self" name="inspectionDuration" />
          </v-row>
        </exo-card-form>
        <exo-card-form label="Simulation parameters">
          <v-row no-gutters justify="start">
            <exo-input-double :root="_self" name="duration" />
            <exo-input-select
              :multiple="true"
              :root="_self"
              name="perturbations"
            >
              <exo-help-dialog title="Perturbations">
                <tooltipPerturbations />
              </exo-help-dialog>
            </exo-input-select>
          </v-row>
        </exo-card-form>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="this.modalRef" />
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import tooltipInspectionMission from '../../components/Tooltips/Toolbox/tooltipInspectionMission'
import tooltipPerturbations from '../../components/Tooltips/tooltipPerturbations'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'InspectionSimulationRequest',

  // mixins: [formMixin, analyticalMixin],
  mixins: [formMixin, numericalMixin],

  components: { tooltipPerturbations, tooltipInspectionMission },

  computed: {
    ...mapGetters(['currentMission']),

    perturbationWatcher() {
      return this.inputs.perturbations
    },

    spacecraftWatcher() {
      return this.inputs.spacecraft
    }
  },

  async mounted() {
    await this.refreshOrbits()
    await this.refreshSpacecrafts()
  },

  watch: {
    perturbationWatcher(value) {
      this.inputs.chiefPerturbations = value
    },
    spacecraftWatcher(value) {
      this.inputs.deputySpacecraft = value
    }
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'initialOrbit', text: 'Leader orbit', sortable: true },
        {
          value: 'distanceFromChief',
          text:
            'Minimum distance from chief' +
            this.getDefaultUnitLabel('distanceFromChief'),
          sortable: true
        },
        {
          value: 'inspectionDuration',
          text:
            'Inspection duration' +
            this.getDefaultUnitLabel('inspectionDuration'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      enumPropertiesList: this.getEnumProperties(),
      modalRef: { content: [] },
      showModal: false,
      spacecraftsNotParametrics: [],
      orbitsNotParametrics: [],
      inputs: {
        type: 'Inspection mission',
        spacecraft: this.getDefaultValue('spacecraft'),
        initialOrbit: this.getDefaultValue('initialOrbit'),
        ephemeridesRequested: this.getDefaultValue('ephemeridesRequested'),
        ephemeridesFileTypesRequested: this.getDefaultValue(
          'ephemeridesFileTypesRequested'
        ),
        ephemeridesStepInSeconds: this.getDefaultValue(
          'ephemeridesStepInSeconds'
        ),
        duration: this.getDefaultValue('duration'),
        chiefPerturbations: [],
        perturbations: [],
        attitudeAndSystemSimulated: this.getDefaultValue(
          'attitudeAndSystemSimulated'
        ),
        inspectionDuration: this.getDefaultValue('inspectionDuration'),
        deputySpacecraft: this.getDefaultValue('deputySpacecraft'),
        relativePositionFromReferenceX: this.getDefaultValue(
          'relativePositionFromReferenceX'
        ),
        relativePositionFromReferenceY: this.getDefaultValue(
          'relativePositionFromReferenceY'
        ),
        relativePositionFromReferenceZ: this.getDefaultValue(
          'relativePositionFromReferenceZ'
        ),
        relativePositionFromReferenceVX: this.getDefaultValue(
          'relativePositionFromReferenceVX'
        ),
        relativePositionFromReferenceVY: this.getDefaultValue(
          'relativePositionFromReferenceVY'
        ),
        relativePositionFromReferenceVZ: this.getDefaultValue(
          'relativePositionFromReferenceVZ'
        ),
        distanceFromChief: this.getDefaultValue('distanceFromChief'),
        deputyInitialOrbit: this.getDefaultValue('deputyInitialOrbit'),
        lof: this.getDefaultValue('lof'),
        linearModelType: this.getDefaultValue('linearModelType'),
        freeFlyingAttitudeMode: this.getDefaultValue('freeFlyingAttitudeMode')
      }
    }
  },

  methods: {
    getCurrentFormType() {
      return 'InspectionSimulationRequest'
    },

    async refreshSpacecrafts() {
      let self = this
      await this.$http
        .get(this.getAPI('spacecraftdefinitions'))
        .then((response) => {
          self.spacecraftsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of spacecrafts. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    async refreshOrbits() {
      let self = this
      await this.$http
        .get(this.getAPI('orbitdefinitions'))
        .then((response) => {
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of orbits. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getRefList(param) {
      return []
    },
    overview(mission) {
      this.sendMissionEventAfterRedirectionToDashboard(
        'set-current-mission',
        mission
      )
    },

    sendMissionEventAfterRedirectionToDashboard(eventName, mission) {
      this.resetCurrentMission()
      this.$router.push({
        path: '/' + 'inspectionsimulationdashboard'
      })
      // event send to root because it should be treated by sub components
      // use nextTick to be sure mission components are created and can handle events
      Vue.nextTick(() => {
        this.$root.$emit(eventName, mission)
      })
    },
    resetCurrentMission() {
      // immediate effect
      this.$root.$emit('set-current-mission', null)
    },

    getFieldState(parentObject, fieldName, required) {
      let fieldState = numericalMixin.methods.getFieldState.call(
        this,
        parentObject,
        fieldName,
        required
      )
      if (fieldName === 'spacecraft' && parentObject.spacecraft != null) {
        let thrusterAcceleration =
          parentObject.spacecraft.thruster.thrust /
          (parentObject.spacecraft.platformMass +
            parentObject.spacecraft.thruster.totalMass)
        if (thrusterAcceleration < 1.4e-4) {
          fieldState.value = false
          fieldState.message =
            'Spacecraft need a propulsion system with thrust acceleration higher than 1.4e-4 to do inspection mission. Please increase the propulsion thrust or decrease the spacecraft mass.'
        }
      }
      if (
        fieldName === 'relativePositionFromReferenceX' &&
        this.inputs.relativePositionFromReferenceX < 1000 &&
        this.inputs.relativePositionFromReferenceX > -1000
      ) {
        fieldState.value = false
        fieldState.message =
          'Initial along-track position must be at least at 1km from the target.'
      }
      if (
        fieldName === 'initialOrbit' &&
        parentObject.initialOrbit != null &&
        (parentObject.initialOrbit.perigeeAltitude > 2000000 ||
          parentObject.initialOrbit.eccentricity > 2e-3)
      ) {
        fieldState.value = false
        fieldState.message =
          'Inspection mission only works on LEO near circular orbit (altitude < 2000km and eccentricity < 4e-3).'
      }
      return fieldState
    },
    onSave: function (evt) {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false

          //this.$root.$emit('update-mission-list')

          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard

          this.$router.push({ path: '/inspectionsimulationdashboard' })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    checkValidNumber(value) {
      let feedback = true
      if (value !== '') {
        let numberValue = Number(value)
        if (numberValue !== null) {
          if (isNaN(numberValue)) {
            feedback = 'Please input a valid number.'
          }
        }
      }
      return feedback
    }
  }
}
</script>
